import { escapeHTML } from '../../../../utility/html.util.service';

export default function EquipmentListFastDirective($state, gettextCatalog, mapService) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      equipmentList: '=',
      direct: '=',
    },
    replace: true,
    transclude: false,
    link: (scope, element) => {
      let html = ``;

      // For translating messages
      const msgUpcoming = gettextCatalog.getString('This asset has a maintenance plan upcoming');
      const msgAlertLow = gettextCatalog.getString('This asset has a low priority alert');
      const msgAlertMed = gettextCatalog.getString('This asset has a medium priority alert');
      const msgAlertHigh = gettextCatalog.getString('This asset has a high priority alert');
      const msgDue = gettextCatalog.getString('This asset has a due maintenance plan');
      const msgShareinbound = gettextCatalog.getString(
        'This asset has been shared to your account',
      );
      const msgMakeModelNA = gettextCatalog.getString('Make and Model N/A');

      const onClickItem = (event) => {
        // eslint-disable-next-line no-undef
        const equipmentId = $(event.target).closest('.g-result').attr('data-equipment');

        if (scope.equipmentList) {
          // eslint-disable-next-line no-undef
          const equipment = _.find(scope.equipmentList, (e) => {
            // eslint-disable-next-line eqeqeq
            return e.id == equipmentId;
          });

          if (equipment) {
            if (scope.direct) {
              $state.go('equipment.detail', {
                equipmentId,
              });
            } else {
              // Stay on the map!
              mapService.setSelectedEquipment(equipment);
              $state.go('map.equipment.detail', {
                equipmentId,
              });
            }
          }
        }
      };

      if (scope.equipmentList) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < scope.equipmentList.length; i++) {
          const equipment = scope.equipmentList[i];
          html += `
            <div class="g-result tr-results-wrapper" data-equipment="${escapeHTML(equipment.id)}">
              <div class="row">
                <div class="col-xs-12">
                  <div class="container-fluid g-result-text">
                    <div class="col-xs-8">
                      <div class="row">
                        <div class="g-result-number">${escapeHTML(equipment.name) || 'N/A'}</div>
          `;

          if (equipment.attrs.make || equipment.attrs.model) {
            let text = '';

            if (equipment.attrs.make) {
              text += equipment.attrs.make;
            }

            if (equipment.attrs.model) {
              if (equipment.attrs.make) {
                text += ' ';
              }
              text += equipment.attrs.model;
            }

            html += `<div class="g-result-details">${escapeHTML(text)}</div>`;
          } else {
            html += `<div class="g-result-details" style="font-size: small;"><i>${msgMakeModelNA}</i></div>`;
          }

          html += `</div></div><div class="col-xs-4 pull-right">`;

          // Equipment status

          if (equipment.properties.indexOf('alert:low') >= 0) {
            html += `<span class="fa fa-exclamation-circle pull-right" title="${msgAlertLow}"></span>`;
          }
          if (equipment.properties.indexOf('alert:medium') >= 0) {
            html += `<span class="fa fa-exclamation-circle pull-right color-medium-priority" title="${msgAlertMed}"></span>`;
          }
          if (equipment.properties.indexOf('alert:high') >= 0) {
            html += `<span class="fa fa-exclamation-circle pull-right color-high-priority" title="${msgAlertHigh}"></span>`;
          }
          if (equipment.properties.indexOf('maintenance:upcoming') >= 0) {
            html += `<span class="fa fa-wrench pull-right color-low-priority" title="${msgUpcoming}"></span>`;
          }

          if (equipment.properties.indexOf('maintenance:due') >= 0) {
            html += `<span class="fa fa-wrench pull-right color-high-priority" title="${msgDue}"></span>`;
          }

          if (equipment.properties.indexOf('sharestatus:inbound') >= 0) {
            html += `<span class="fa fa-share-alt pull-right" title="${msgShareinbound}"></span>`;
          }
          html += `</div></div></div></div></div>`;
        }
      }

      // eslint-disable-next-line no-undef
      element.append(html);
      element.on('click', '.g-result', onClickItem);
    },
  };
}
